export default "__VITE_ASSET__D6OxoZ4y__"